<template>
  <Content class="goodsBox">
    <Card>
      <div slot="title">
        <span>订单列表</span>
      </div>

      <!-- 筛选表单 -->
      <Form id="searchForm" :model="formItem" :label-width="45" inline>
        <FormItem label="关键字">
          <Input v-model="formItem.keyword" placeholder="地址、用户名称" clearable style="width: 180px;" />
        </FormItem>
        <FormItem label="订单状态">
          <Select v-model="formItem.status" multiple clearable placeholder="全部状态" style="width: 180px;">
            <Option v-for="item in statusOptions" :key="item.value" :value="item.value">
              {{ item.label }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="区域">
          <Select v-model="formItem.areaId" multiple clearable placeholder="全部区域" style="width: 180px;">
            <Option v-for="item in areas" :key="item.area_id" :value="item.area_id">
              {{ item.area_name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="时间范围">
          <DatePicker 
            v-model="formItem.dateRange" 
            type="datetimerange" 
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间范围"
            style="width: 300px;"
          ></DatePicker>
        </FormItem>
        <FormItem label-width="0">
          <Button type="primary" @click="search">查询</Button>
          <Button style="margin-left: 8px" @click="clear">重置</Button>
          <Button type="primary" icon="ios-download-outline" style="margin-left: 8px" @click="showExportModal = true">导出</Button>
          <Button 
            type="error" 
            icon="ios-trash-outline" 
            :disabled="selectedOrders.length === 0"
            @click="handleBatchUpdate"
            style="margin-left: 8px;"
          >
            批量操作
          </Button>
        </FormItem>
      </Form>

      <!-- 订单列表 -->
      <Table
        :columns="columns"
        :data="tableData"
        :height="tablesHeight"
        border
        @on-selection-change="handleSelectionChange"
      ></Table>
      <!-- 分页 -->
      <Page
        class="table_page_css"
        v-show="total"
        :total="total"
        :current="searchInfo.pageNo"
        :page-size="searchInfo.pageSize"
        :page-size-opts="pageSizeOpts"
        @on-change="pageNoChange"
        @on-page-size-change="pageSizeChange"
        show-sizer
        show-elevator
        show-total
      />
    </Card>

    <!-- 导出对话框 -->
    <Modal v-model="showExportModal" title="导出订单" @on-ok="handleExport('excel')">
      <p>确定要导出当前筛选条件下的订单吗？</p>
      <p style="color: #909399; font-size: 12px; margin-top: 8px;">
        导出格式：Excel（.xlsx）
      </p>
    </Modal>
  </Content>
</template>
<script>
import { getOrderList, filterOrders, exportOrders, batchUpdateOrders } from '@/api/order'
export default {
  name: 'Order',

  data() {
    return {
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          type: 'index',
          width: 60,
          align: 'center',
        },
        {
          title: '订单ID',
          key: '_id',
          width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: '#409EFF', cursor: 'pointer' },
              on: {
                click: () => this.viewDetail(params.row._id)
              }
            }, params.row._id.toString().slice(-8))
          },
        },
        {
          title: '订单状态',
          key: 'command',
          width: 100,
          render: (h, params) => {
            const status = params.row.command
            const statusMap = {
              0: { name: '待分配', color: 'default' },
              1: { name: '已分配', color: 'primary' },
              2: { name: '前往中', color: 'success' },
              3: { name: '已到达', color: 'warning' },
              4: { name: '使用中', color: 'error' },
              5: { name: '归还中', color: 'default' },
              6: { name: '已完成', color: 'success' },
              7: { name: '已取消', color: 'error' },
              8: { name: '故障', color: 'error' }
            }
            const statusInfo = statusMap[status] || { name: '未知', color: 'default' }
            return h('Tag', {
              props: { color: statusInfo.color }
            }, statusInfo.name)
          },
        },
        {
          title: '车辆名称',
          key: 'car_details.car_name',
          render: (h, params) => {
            return h(
              'div',
              params.row.car_details ? params.row.car_details.car_name : '-',
            )
          },
        },
        {
          title: '客户',
          key: 'user_details.nickname',
          render: (h, params) => {
            const userDetails = params.row.user_details;
            if (!userDetails) {
              return h('span', '-');
            }
            // 优先使用 nickName，如果没有则使用 nickname
            const nickname = userDetails.nickName || userDetails.nickname || '-';
            return h('div', nickname);
          },
        },
        {
          title: '电话',
          key: 'user_details.phone',
          render: (h, params) => {
            return h(
              'div',
              params.row.user_details ? params.row.user_details.phone : '-',
            )
          },
        },
        {
          title: '订单金额',
          key: 'total_price',
          width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: '#f56c6c', fontWeight: 'bold' }
            }, `¥${(params.row.total_price || 0).toFixed(2)}`)
          },
        },
        {
          title: '下单区域',
          key: 'area_details.area_name',
          render: (h, params) => {
            return h(
              'div',
              params.row.area_details ? params.row.area_details.area_name : '-',
            )
          },
        },
        {
          title: '订单时间',
          key: 'create_time',
          width: 180,
          render: (h, params) => {
            return h('div', this.formatTime(params.row.create_time))
          },
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => this.viewDetail(params.row._id)
                }
              }, '详情')
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      selectedOrders: [],
      searchInfo: {
        pageNo: 1,
        pageSize: 10,
        areas: []
      },
      pageSizeOpts: [10, 20, 50, 100],
      formItem: {
        keyword: '',
        status: [],
        areaId: [],
        dateRange: []
      },
      statusOptions: [
        { label: '待分配', value: 0 },
        { label: '已分配', value: 1 },
        { label: '前往中', value: 2 },
        { label: '已到达', value: 3 },
        { label: '使用中', value: 4 },
        { label: '归还中', value: 5 },
        { label: '已完成', value: 6 },
        { label: '已取消', value: 7 },
        { label: '故障', value: 8 }
      ],
      tablesHeight: 0,
      showExportModal: false,
    }
  },
  computed: {
    areas() {
      return JSON.parse(this.$store.state.areas)
    }
  },
  methods: {
    // 设置表格高度
    setTablesHeight() {
      let aH = 0
      let oA = document.getElementById('app')
      let oH = oA.clientHeight || oA.offsetHeight
      let sA = document.getElementById('searchForm')
      let sH = sA.clientHeight || sA.offsetHeight
      aH = oH - sH - 320
      this.tablesHeight = aH
    },

    // 获取订单列表
    async getList() {
      try {
        // 使用增强的筛选接口
        const filters = {
          status: this.formItem.status,
          areaId: this.formItem.areaId,
          keyword: this.formItem.keyword,
          dateRange: this.formItem.dateRange,
          page: this.searchInfo.pageNo,
          pageSize: this.searchInfo.pageSize
        }

        // 移除空值
        Object.keys(filters).forEach(key => {
          if (filters[key] === null || filters[key] === undefined || 
              (Array.isArray(filters[key]) && filters[key].length === 0)) {
            delete filters[key]
          }
        })

        const res = await filterOrders(filters)
        if (res.data.code === 200 && res.data.success) {
          // 后端返回格式: { data: { list: [...], pagination: {...} } }
          const responseData = res.data.data || {}
          this.tableData = Array.isArray(responseData.list) ? responseData.list : []
          this.total = responseData.pagination?.total || 0
        } else {
          this.$Message.error(res.data.message || res.data.msg || '获取订单列表失败')
        }
      } catch (error) {
        console.error(error)
        this.$Message.error('获取订单列表失败')
      }
    },

    // 搜索
    search() {
      this.searchInfo.pageNo = 1
      this.getList()
    },

    // 重置
    clear() {
      this.formItem = {
        keyword: '',
        status: [],
        areaId: [],
        dateRange: []
      }
      this.searchInfo.pageNo = 1
      this.getList()
    },

    // 查看订单详情
    viewDetail(orderId) {
      this.$router.push({
        name: 'order-detail',
        params: { id: orderId }
      })
    },

    // 选择变化
    handleSelectionChange(selection) {
      this.selectedOrders = selection.map(item => item._id)
    },

    // 批量操作
    handleBatchUpdate() {
      if (this.selectedOrders.length === 0) {
        this.$Message.warning('请先选择订单')
        return
      }
      this.$Modal.confirm({
        title: '批量更新订单状态',
        content: `确定要批量更新 ${this.selectedOrders.length} 个订单的状态吗？`,
        onOk: async () => {
          try {
            // 这里可以弹出选择状态的对话框
            this.$Modal.confirm({
              title: '选择目标状态',
              render: (h) => {
                return h('Select', {
                  props: { value: 6 },
                  on: {
                    'on-change': (value) => {
                      this.batchUpdateStatus = value
                    }
                  }
                }, this.statusOptions.map(opt => {
                  return h('Option', {
                    props: { value: opt.value, label: opt.label }
                  })
                }))
              },
              onOk: async () => {
                const res = await batchUpdateOrders({
                  orderIds: this.selectedOrders,
                  status: this.batchUpdateStatus || 6,
                  remark: '批量更新'
                })
                if (res.data.code === 200) {
                  this.$Message.success('批量更新成功')
                  this.selectedOrders = []
                  this.getList()
                } else {
                  this.$Message.error(res.data.msg || '批量更新失败')
                }
              }
            })
          } catch (error) {
            this.$Message.error('批量更新失败')
          }
        }
      })
    },

    // 导出订单
    async handleExport(format = 'excel') {
      try {
        const filters = {
          status: this.formItem.status,
          areaId: this.formItem.areaId,
          keyword: this.formItem.keyword,
          dateRange: this.formItem.dateRange,
          format,
          fields: [] // 导出所有字段
        }

        const res = await exportOrders(filters)
        
        // 创建下载链接
        const blob = new Blob([res.data], {
          type: format === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `订单列表_${new Date().toISOString().slice(0, 10)}.${format === 'csv' ? 'csv' : 'xlsx'}`
        link.click()
        window.URL.revokeObjectURL(url)
        
        this.$Message.success('导出成功')
        this.showExportModal = false
      } catch (error) {
        this.$Message.error('导出失败')
        console.error(error)
      }
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN')
    },

    // 分页变化
    pageNoChange(current) {
      this.searchInfo.pageNo = current
      this.getList()
    },

    // 页大小变化
    pageSizeChange(val) {
      this.searchInfo.pageNo = 1
      this.searchInfo.pageSize = val
      this.getList()
    },
  },
  mounted() {
    // 默认查所有区域
    const allAreaIds = this.areas.map(item => item.area_id)
    this.searchInfo.areas = allAreaIds
    this.getList()
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
<style lang="less" scoped>
.goodsBox {
  /deep/ .ivu-form-inline .ivu-form-item {
    margin-right: 8px;
    margin-bottom: 0;
    vertical-align: middle;
    
    .ivu-form-item-label {
      text-align: right;
      padding-right: 0 !important; // 移除标签右边距
      margin-right: 0 !important; // 移除标签外边距
      width: auto;
      min-width: auto;
    }
    
    .ivu-form-item-content {
      display: inline-flex;
      align-items: center;
      margin-left: 4px !important; // 只在标签和输入框之间留最小间距
    }
  }
  
  #searchForm {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    
    /deep/ .ivu-form-item {
      display: inline-flex;
      align-items: center;
      margin-bottom: 0;
      
      .ivu-form-item-label {
        padding-right: 0 !important;
        margin-right: 0 !important;
      }
      
      .ivu-form-item-content {
        margin-left: 4px !important;
      }
    }
  }
}
</style>
